<div id="contentWrap" class="container">

    <div class="modify row" style="margin-top:100px;">
        <!--  LEFTNAV -->
        <div id="leftnav" class="col-md-3">
            <div class="chatPeople">
                <div class="filter">
                    <input type="text" id="searchFieldMessagingCustomers" [(ngModel)] = "searchText"  placeholder="Search hotel" name="search_people">
                    <a class="searchFilter"></a>
                </div>
                <div class="sort">
                    <span>Sort by</span>
                    <select id="sortbyMessaging" (change)="sortMessaging($event.target.value)" >
                        <option selected="">Most recent</option>
                        <option>Username Ascending</option>
                        <option>Username Descending</option>
                    </select>
                </div>
                <ul style="height: 604px;">
                    <li *ngFor="let messageThread of messages | searchfilter : searchText; let i = index" (click) = "setSelectedThread(messageThread.id)"
                        [ngClass] = "messageThread.id === selectedMessage.id? 'current': ''">
                            <div class="usrPic" [ngStyle]="{'background-image': 'url(' + sidebarInfo[i].lastThumbnail + ')'}" 
                            title="Thanos Pappas"></div>
                            <div class="date">{{sidebarInfo[i].dateSent | date:'mediumDate'}}</div>
                            <div class="lastMsg">{{messageThread.hotelName}}</div>
                            <a class="dltConv" data-threadid="91" (click)="deleteMessageThread(messageThread.id)"></a>
                        </li>

                </ul>
        </div>
    </div>
    <!-- END LEFTNAV -->
    <div class="col-md-9">
        <div class="modifyWrap">
            <div class="contentBtns">
                <div class="historyHeader">
                    <div class="btnWrap">
                        <div class="freq">
                            From <span class="freqDate" id="viewFromDate">{{startDate}}</span>
                            to <span class="freqDate" id="viewToDate">{{endDate}}</span>
                        </div>
                    </div>
                </div>
                <div class="historyHeader">
                    <input name="search_field" id="searchFieldMessagingChat"  (input)="onSearchChange($event.target.value)" placeholder="User name, date or keyword" type="text">
                </div>
                <div class="historyHeader">
                        <div class="btnWrap">
                        <button (click)="togglePeriodCard()" class="gradient">Choose period</button>
                        <div *ngIf="!hiddenPeriod" class="periodWrap gradient">
                            <h3>Choose period</h3>
                 
                            <div class="historyFromTo inputHolder col-md-12">
                                    
                                    <form class="form-inline">
                                      <div class="form-group">
                                        <div class="input-group col-md-12">
                                                <label>From</label>
                                          <input class="form-control fromDate hasDatepicker" placeholder={{checkin}}
                                                 name="d1" #c1="ngModel" [(ngModel)]="checkin" (dateSelect)="filterMassages()" 
                                                 ngbDatepicker #d1="ngbDatepicker" 
                                                 style="border-radius: 0 !important;" (click)="d1.toggle()">
                                        </div>
                                      </div>
                                    </form>
                                    <form class="form-inline">
                                      <div class="form-group">
                                        <div class="input-group col-md-12">
                                                <label>to</label>
                                          <input class="form-control fromDate hasDatepicker col-xs" placeholder={{checkout}}
                                                 name="d2" #c2="ngModel" [(ngModel)]="checkout"
                                                  (dateSelect)="filterMassages()" ngbDatepicker #d2="ngbDatepicker" 
                                                  style="border-radius: 0 !important;" (click)="d2.toggle()">
                                          
                                        </div>
                                      </div>
                                    </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="contentWrap">
            <div id="mainBox" style="display: inline;">
                <div class="content">
                    <div class="chatHeader">
                        <h3>Chat with <span class="hasStar" *ngIf="selectedMessage">{{selectedMessage.messageCollection[0].customerId.name}} 
                            {{selectedMessage.messageCollection[0].customerId.surname}}</span></h3>
                        <a class="deleteChat" data-threadid="91" (click)="deleteMessageThread(selectedMessage.id)">Delete this chat</a>
                    </div>

                    <div class="chatBox" style="height: 10px;"> 
                        <div class="allMsgTbl">
                            <div class="allMsgRow">
                                <div class="allMsgCell" >
                                    
                                    <div #scrollMe [scrollTop]="scrollMe.scrollHeight" class="allMsgScroll" *ngIf="selectedMessage">
                                        <div *ngFor="let message of selectedMessage.messageCollection | chatFilter: chatFilters: updated" 
                                        [ngClass]="message.userId === null ? 'usrMsg client': 'usrMsg'">
                                            <div class="usrMeta">
                                                    
                                                <div class="usrPic" 
                                                [ngStyle]="{'background-image': 'url(' +getUserThumbnail(message) +')'}" 
                                                title="{{message.customerId.name}}"></div>
                                                <div class="usrTxt">
                                                    <span>{{message.text}}</span>
                                                    <span class="msgDateTime">{{getDate(message.timeSent) | date:'medium' }}</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="usrInput">
                        <textarea [(ngModel)] = "userText" placeholder="Write a reply..."></textarea>
                        <a class="btnReply" (click)="sendMessage()">Reply</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>